// extracted by css-extract-rspack-plugin
export default {"items":"_996c3b05","item":"_6d740f36","image":"_cf03dd64"};